export function saintnectaireDetailPage(): string {
  return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="sn-title">
        <div class="card overflow-hidden">
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Mobile</span>
              <span class="tag">Maquettes</span>
              <span class="tag">Editorial</span>
            </div>
            <h1 id="sn-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Site éditorial local</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Proposition graphique mobile pour un site éditorial local. Livrable : maquettes haute fidelite mobile uniquement.
            </p>
          </div>

          <!-- Side-by-side images -->
          <div class="grid sm:grid-cols-2 gap-4 p-6 sm:p-10 pt-0">
            <div class="rounded-2xl overflow-hidden" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-iphone"]')?.getAttribute('src') || ''}"
                   alt="Site éditorial local - Maquette mobile sur iPhone"
                   class="w-full h-auto"
                   loading="eager"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center p-8\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="rounded-2xl overflow-hidden" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-accueil"]')?.getAttribute('src') || ''}"
                   alt="Site éditorial local - Vue d'ensemble de la maquette"
                   class="w-full h-auto"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center p-8\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
          </div>

          <div class="px-6 sm:px-10 pb-8">
            <p class="font-body text-body-md" style="color: var(--text-secondary)">
              Architecture de l'information optimisee pour un acces rapide aux actualites, newsletters et petites annonces.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet site éditorial local">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-1">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Reponse a appel d'offres pour une proposition graphique mobile uniquement. Cible : organisation locale.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee :</strong> Maquettes haute fidelite mobile, aucune implementation ni developpement.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Visibilite inegale des contenus cles et hierarchie editoriale confuse sur mobile.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Clarifier le message institutionnel</li>
                <li>Acces immediat aux Actualites, Newsletters et Annonces</li>
                <li>Base UI coherente et accessible</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>

            <div class="p-5 rounded-xl mb-4" style="background-color: var(--bg-subtle);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Parcours mobile</h3>
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                Accueil avec blocs empiles : <strong>Actualites</strong>, <strong>Dernieres newsletters</strong>, <strong>Petites annonces</strong>
              </p>
              <p class="font-body text-body-sm mt-1" style="color: var(--text-secondary)">
                Navigation inferieure (tab bar) : <strong>Accueil / Resultats / Actualites / Annonces / Contact</strong>
              </p>
            </div>

            <div class="grid sm:grid-cols-3 gap-4 mb-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Actualites</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste filtrable, cartes titre+date, gabarit article</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Newsletters</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste datee, acces rapide aux editions</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Petites annonces</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste + fiche, CTA "Voir toutes les annonces"</p>
              </div>
            </div>

            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Systeme UI mobile</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Composants reutilisables (cartes, boutons, listes, pagination, formulaires)</li>
                <li>Etats d'interaction et focus visibles</li>
                <li>Recommandations accessibilite et performance</li>
              </ul>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Comprehension immediate</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">de l'offre locale</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Hausse des clics</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">vers Actualites et Annonces</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Coherence visuelle</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">base prete pour industrialisation</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="sn-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="sn-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design mobile</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}
